import { api } from './client';

// --- Types ---

export interface PushNotificationStats {
  pending: number;
  delivered: number;
  partial: number;
  failed: number;
  active_subscriptions: number;
}

export interface PushNotificationEvent {
  id: string;
  title: string;
  body: string;
  url: string;
  tag: string;
  user_name: string;
  status: string;
  devices_total: number;
  devices_success: number;
  devices_failed: number;
  created_at: string | null;
  sent_at: string | null;
  error: string | null;
}

export interface PushNotificationEventList {
  items: PushNotificationEvent[];
  total: number;
  page: number;
  page_size: number;
}

export interface PushUser {
  id: string;
  nome: string;
  email: string;
  devices: number;
}

export interface SendTestPushPayload {
  user_id: string;
  title: string;
  body: string;
  url?: string;
  tag?: string;
}

export interface SendTestPushResponse {
  ok: boolean;
  notification_id: string;
  devices_count: number;
}

export interface PushSubscriptionItem {
  id: string;
  user_id: string;
  user_name: string;
  user_email: string;
  user_agent: string | null;
  created_at: string | null;
  last_success_at: string | null;
  failure_count: number;
}

export interface PushSubscriptionList {
  items: PushSubscriptionItem[];
  total: number;
  page: number;
  page_size: number;
}

// --- API functions ---

export async function fetchPushStats(): Promise<PushNotificationStats> {
  const { data } = await api.get<PushNotificationStats>('/admin/push-notifications/stats');
  return data;
}

export async function fetchPushEvents(params: {
  status?: string;
  search?: string;
  page?: number;
  page_size?: number;
}): Promise<PushNotificationEventList> {
  const { data } = await api.get<PushNotificationEventList>('/admin/push-notifications/events', { params });
  return data;
}

export async function fetchUsersWithPush(search?: string): Promise<PushUser[]> {
  const { data } = await api.get<PushUser[]>('/admin/push-notifications/users-with-push', {
    params: search ? { search } : undefined,
  });
  return data;
}

export async function sendTestPush(payload: SendTestPushPayload): Promise<SendTestPushResponse> {
  const { data } = await api.post<SendTestPushResponse>('/admin/push-notifications/send-test', payload);
  return data;
}

export async function fetchPushSubscriptions(params: {
  search?: string;
  page?: number;
  page_size?: number;
}): Promise<PushSubscriptionList> {
  const { data } = await api.get<PushSubscriptionList>('/admin/push-notifications/subscriptions', { params });
  return data;
}
